import { toast } from "react-toastify"
import { _RequestMaintenanceImplements, _single } from "../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { BasicTable } from "../../../../theme/Component/BasicTable"
import usePaginator from "../../../../theme/Component/usePaginator"
import { useEffect, useState } from "react"
import { ListMenu } from "../../../../theme/Component/ListMenu"
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal"
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm"
import { Modal } from "../../../../theme/Component/Modal"
import { SelectFixedAsset } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset"
import { SelectProductEditor } from "../../../ManufacturingStandars/Components/SelectProductEditor"
import { EditorFixedAssetItem } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/EditorFixedAssetItem"

interface ComponentProps {
    idRequestMaintenance: number;
}

export const RequestMaintenanceImplements = ({ idRequestMaintenance }: ComponentProps) => {

    const { instance, setBean, setLista, bean, lista } = useDataBean(_RequestMaintenanceImplements)
    const paginador = usePaginator();

    const modal = useModal("", MODAL_SM);
    const modalDelete = useModal("Eliminar Implemento", MODAL_SM);

    useEffect(() => getLista(), [])

    const getLista = () => {
        const Props = {
            IDRequestMaintenance: idRequestMaintenance,
            State: 1,
        }

        instance.getRequestMaintenanceImplementsRender(paginador.page, 15, Props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);

                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;
                    data.RenderImplement = data.ImplementType == 100 ? data.FixedAssetDescription : data.ProductName
                });

                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDRequestMaintenance: idRequestMaintenance
        });
        modal.open("Agregar Implemento")
    }


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Implemento") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const head = [
        { title: 'ID', property: 'IDRequestMaintenanceImplements', visible: true },
        { title: 'Tipo de Implemento', property: 'ImplementTypeName', visible: true },
        { title: 'Implemento', property: 'RenderImplement', visible: true },
    ]

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateRequestMaintenanceImplements(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalDelete.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "ImplementType"
        ];

        if (bean.ImplementType == 100) {
            requiredFields.push("IDFixedAssetItem")
        } else if (bean.ImplementType == 101) {
            requiredFields.push("IDProduct")
        }

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    iconButtons={iconButtonsItem}
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('ImplementType') ? 'has-error' : ''}`} >Tipo de Implemento</label>
                            <select value={bean.ImplementType}
                                onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, ImplementType: value })
                                }} className="form-control">
                                <option value="">...</option>
                                <option value="100">Activo Fijo</option>
                                <option value="101">Implemento</option>
                            </select>
                        </div>
                        {bean.ImplementType == 100 &&
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDFixedAssetItem') ? 'has-error' : ''}`} >Activo Fijo</label>
                                <EditorFixedAssetItem idSelector={bean.IDFixedAssetItem} label=" " onChange={(e) => { setBean({ ...bean, IDFixedAssetItem: e.IDItem }) }} />
                            </div>
                        }
                        {bean.ImplementType == 101 &&
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDProduct') ? 'has-error' : ''}`} >Producto</label>
                                <SelectProductEditor filterType={2} value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} label=" " />
                            </div>
                        }
                    </div>
                </Modal>

                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={() => { deleteItem() }} >
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}